/**
 * Parse a UTC timestamp string into a proper Date object.
 * Handles server timestamps that may be missing the 'Z' suffix.
 */
export function parseUTCDate(dateString: string | Date): Date {
  if (dateString instanceof Date) return dateString;

  // If the string doesn't end with 'Z' or timezone info, assume it's UTC and append 'Z'
  if (!dateString.match(/[+-]\d{2}:\d{2}$/) && !dateString.endsWith('Z')) {
    return new Date(dateString + 'Z');
  }

  return new Date(dateString);
}
